module.exports = __webpack_public_path__ + "assets/img/ig-1.b0b90142.png";